import { Enrollment, EnrollmentDto } from './Enrollment';
import { utilities } from 'utils/utilities';

export interface ReviewEnrollmentDto extends EnrollmentDto {
  assignedTeamId: string;
  reviewInstructionsJson?: string;
}

export class ReviewEnrollment extends Enrollment {
  assignedTeamId: string;
  reviewInstructionsJson?: string;
  readonly type: 'ReviewEnrollment' = 'ReviewEnrollment';

  constructor(id: string, assignedTeamId: string, reviewInstructionsJson?: string) {
    super(id);
    this.assignedTeamId = assignedTeamId;
    this.reviewInstructionsJson = reviewInstructionsJson;
  }

  toDto(): ReviewEnrollmentDto {
    return {
      assignedTeamId: this.assignedTeamId,
      reviewInstructionsJson: this.reviewInstructionsJson,
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.ReviewEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
    };
  }

  static fromDto(dto?: Partial<ReviewEnrollmentDto> | ReviewEnrollment | any): ReviewEnrollment {
    if (!dto) {
      return new ReviewEnrollment(utilities.DEFAULT_GUID, utilities.DEFAULT_GUID);
    }

    if (dto instanceof ReviewEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const assignedTeamId = dto.assignedTeamId ?? utilities.DEFAULT_GUID;
    return new ReviewEnrollment(id, assignedTeamId, dto.reviewInstructionsJson);
  }
}

// Self-register to avoid Enrollment needing a hard import
Enrollment.register('ReviewEnrollment', (d?: any) => ReviewEnrollment.fromDto(d));
